import React, { useCallback, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LabelOffOutlinedIcon from '@material-ui/icons/LabelOffOutlined';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { create, date }  from '../util';
import Confirm           from '../Confirm';
import NewNote, { note } from './NewNote';

const style = {
  usedTickets: makeStyles((theme) => ({
    ticket: {
      alignItems: 'center',
      color: 'gray',
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      height: '100%',
      whiteSpace: 'nowrap',
    },
    title: {
      paddingBottom: theme.spacing(2),
    },
  })),
}

export default function UsedTickets(props) {
  const classes = style.usedTickets();

  const {
    request,
    setSnackbarMessage,
  } = props.context.getStates();

  const [ count, setCount ] = useState(0);
  const [ newNote, setNewNote ] = useState(note());
  const [ page, setPage ] = useState(0);
  const [ newUsableTicket, setNewUsableTicket] = useState(create.issuedTicket());
  const [ usedTickets, setUsedTickets ] = useState([]);

  const fetchUsedTickets = useCallback((page) => {
    request.postSecurely('/attender/issued/used', {
      attender: props.attender.rowid,
      page,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        if ('count' in response) {
          setCount(response.count);
        }
        if ('tickets' in response) {
          setUsedTickets(response.tickets);
        }
      }
    });
  }, [request, props.attender.rowid]);

  const updateNote = () => {
    request.postSecurely('/attender/issued/update', {
      ...newNote,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        setNewNote(note());
        props.setRevision(props.revision + 1);
      }
    });
  }

  const updateTicketUsable = () => {
    request.postSecurely('/attender/issued/update', {
      rowid: newUsableTicket.rowid,
      usedAt: 0,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else {
        setNewUsableTicket(create.issuedTicket());
        setSnackbarMessage(
          `${date.used(newUsableTicket.usedAt)} ${newUsableTicket.usable ? '사용' : '만료'} 내역이 취소되었습니다.`
        );
        props.setRevision(props.revision + 1);

      }
    });
  }

  useEffect(() => {
    fetchUsedTickets(0);
  }, [
    fetchUsedTickets,
    props.revision,
  ]);

  return (
    <div>
      <Confirm open={newUsableTicket.rowid > -1}
        requestTitle={(<div>
          <div>{'다음 '}{newUsableTicket.usable ? '사용' : '만료'}{' 내역을 취소하시겠습니까?'}</div>
        </div>)}
        requestBody={(<div>
          <div><b>{newUsableTicket.name}</b></div>
          <div>{date.used(newUsableTicket.usedAt)}</div>
        </div>)}
        onConfirmed={() => { updateTicketUsable(); }}
        onDisconfirmed={() => { setNewUsableTicket(create.issuedTicket()); }}
      />

      <NewNote newNote={newNote}
        note={note}
        setNewNote={setNewNote}
        updateNote={updateNote}
      />

      <Typography variant="h6" className={classes.title}>{'티켓 사용 내역'}</Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {['티켓 ID', '발급일', '사용일', '이용권', '비고', ''].map((column, index) => (
                <TableCell key={index}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {usedTickets.map((ticket) => (
              <TableRow hover tabIndex={-1} key={ticket['issued.rowid']}>
                <TableCell>
                  {ticket['issued.rowid']}
                </TableCell>
                <TableCell>
                  {date.withoutTime(ticket['issued.date'])}
                </TableCell>
                <TableCell>
                  {ticket['issued.usable'] ? date.used(ticket['issued.used_at']) : (
                    <strike style={{color: 'lightgray'}}>
                      {date.used(ticket['issued.used_at'])}
                    </strike>
                  )}
                </TableCell>
                <TableCell>
                  <div className={classes.ticket}>
                    <LabelOffOutlinedIcon />
                    <strike><b>{ticket['ticket.name']}</b></strike>
                    <Button color="secondary"
                      onClick={(event) => {
                        setNewUsableTicket(create.issuedTicket({
                          color: ticket['ticket.color'],
                          name: ticket['ticket.name'],
                          rowid: ticket['issued.rowid'],
                          usable: ticket['issued.usable'],
                          usedAt: ticket['issued.used_at'],
                        }));
                      }}
                    >{(ticket['issued.usable'] ? '사용' : '만료') + ' 취소'}</Button>
                  </div>
                </TableCell>
                <TableCell>
                  {ticket['issued.note'].split('\n').map((line, index) => (
                    <span key={index}>{line}<br/></span>
                  ))}
                </TableCell>
                <TableCell align={'right'}>
                  <Button onClick={(event) => {
                      setNewNote(note(ticket['issued.rowid'], ticket['issued.note']));
                    }}
                  >{'수정'}</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={count}
        onPageChange={(event, newPage) => { fetchUsedTickets(newPage); setPage(newPage); }}
        page={page}
        rowsPerPage={5}
        rowsPerPageOptions={[]}
      />
    </div>
  );
}
